export default __webpack_public_path__ + "images/models/ed56324bd428d5401d742c77dbe7b377.usdz";